"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Branch factory
 * formats the raw data into a usable format
 */
const get_1 = __importDefault(require("lodash/get"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const DISTANCE_UNIT_1 = __importDefault(require("../../../constants/app/DISTANCE_UNIT"));
const DATE_TIME_PICKER_1 = __importDefault(require("../../../constants/date/DATE_TIME_PICKER"));
const LANG_1 = __importDefault(require("../../../constants/lang/LANG"));
const getHolidays_1 = __importDefault(require("../../utils/branch/getHolidays"));
const getOffDays_1 = __importDefault(require("../../utils/branch/getOffDays"));
const getOnDays_1 = __importDefault(require("../../utils/branch/getOnDays"));
const getSpecialTiming_1 = __importDefault(require("../../utils/branch/getSpecialTiming"));
const getTimingSummary_1 = __importDefault(require("../../utils/branch/getTimingSummary"));
/**
 * Returns formatted branch info
 * @param {BranchType} branch
 * @param {string} language
 * @returns {BranchFactoryType}
 */
function branchFactory(branch, language = LANG_1.default.EN) {
    const branchTimings = (0, get_1.default)(branch, 'timings', []);
    const holidays = (0, get_1.default)(branch, 'holidays', []);
    const specialTimings = (0, get_1.default)(branch, 'specialTimings', []);
    const returnData = {
        id: (0, get_1.default)(branch, 'id', 0),
        type: (0, get_1.default)(branch, 'type', ''),
        phoneNumber: (0, get_1.default)(branch, 'phoneNumber', ''),
        name: (0, get_1.default)(branch, `name.${language}`, ''),
        nameEn: (0, get_1.default)(branch, 'name.en', ''),
        code: (0, get_1.default)(branch, 'code', ''),
        distance: (0, get_1.default)(branch, 'distance', 0),
        directions: (0, get_1.default)(branch, 'directions', ''),
        distanceUnit: DISTANCE_UNIT_1.default,
        email: (0, get_1.default)(branch, 'email', ''),
        lat: (0, get_1.default)(branch, 'latitude', 0),
        long: (0, get_1.default)(branch, 'longitude', 0),
        cityName: (0, get_1.default)(branch, `city.name.${language}`, ''),
        cityNameEn: (0, get_1.default)(branch, 'city.name.en', ''),
        cityId: (0, get_1.default)(branch, 'city.id', 0),
        carDelivery: (0, get_1.default)(branch, 'carDelivery', false),
        regionName: (0, get_1.default)(branch, `city.region.name.${language}`, ''),
        regionId: (0, get_1.default)(branch, 'city.region.id', 0),
        leadTimeMinutes: (0, get_1.default)(branch, 'leadTimeMinutes', DATE_TIME_PICKER_1.default.T_PLUS_240_M), // 240 min == 4 hrs
    };
    // if branch has timings array
    if (!(0, isEmpty_1.default)(branchTimings)) {
        returnData.timingSummary = (0, getTimingSummary_1.default)(branchTimings);
        returnData.offDays = (0, getOffDays_1.default)(branchTimings);
        returnData.onDays = (0, getOnDays_1.default)(branchTimings);
    }
    if (!(0, isEmpty_1.default)(holidays)) {
        returnData.holidays = (0, getHolidays_1.default)(holidays);
    }
    if (!(0, isEmpty_1.default)(specialTimings)) {
        returnData.specialTimings = (0, getSpecialTiming_1.default)(specialTimings);
    }
    return returnData;
}
exports.default = branchFactory;
